import React from 'react';

const team = [
  { name:'Lena Pearce',    role:'Chief Business Officer',       initials:'LP', c:'red'  },
  { name:'Sophia Bach',    role:'Business Development Manager', initials:'SB', c:'blue' },
  { name:'Arielle Copper', role:'Client Engagement Director',   initials:'AC', c:'red'  },
  { name:'Marcus Chen',    role:'Independent Director',         initials:'MC', c:'blue' },
  { name:'Emma Rodriguez', role:'Content Writer',               initials:'ER', c:'red'  },
];

export default function Team() {
  return (
    <section id="team" className="section bg-dark">
      <div className="max-w-content mx-auto">

        <div className="text-center max-w-xl mx-auto mb-16 reveal">
          <span className="label label-blue">People</span>
          <h2 className="heading mt-5">Our <em style={{ color:'var(--blue)' }}>Team</em></h2>
          <div className="divider blue center wide mt-5 mb-5" />
          <p className="subtext text-sm">The people behind every campus activation.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {team.map((m, i) => (
            <div key={m.name} className={`team-card ${m.c === 'red' ? 'red-hover' : 'blue-hover'} reveal d${i+1}`}>
              {/* Top accent */}
              <div className="h-[3px] w-full" style={{ background: m.c === 'red' ? 'var(--red)' : 'var(--blue)' }} />

              <div className="p-6">
                {/* Avatar */}
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center font-black text-xl mb-5"
                  style={{
                    fontFamily: 'Playfair Display,serif',
                    background: m.c === 'red' ? 'rgba(255,0,50,.12)' : 'rgba(5,131,242,.12)',
                    border: `1.5px solid ${m.c === 'red' ? 'rgba(255,0,50,.25)' : 'rgba(5,131,242,.25)'}`,
                    color: m.c === 'red' ? 'var(--red)' : 'var(--blue)',
                  }}>
                  {m.initials}
                </div>

                <h4 className="text-white font-bold text-sm leading-tight mb-1">{m.name}</h4>
                <p className="text-white/42 text-xs mb-4 font-medium">{m.role}</p>
                <p className="text-white/28 text-xs leading-relaxed">
                  Dedicated professional bringing expertise and passion to every campus engagement.
                </p>

                {/* Social placeholder */}
                <div className="mt-5 flex gap-2">
                  <div className="w-7 h-7 rounded-lg flex items-center justify-center"
                    style={{ background:'rgba(255,255,255,.05)', border:'1px solid rgba(255,255,255,.08)' }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" stroke="rgba(255,255,255,.4)" strokeWidth="1.5"/>
                      <circle cx="4" cy="4" r="2" stroke="rgba(255,255,255,.4)" strokeWidth="1.5"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
